/* NZS-SPD-0820 - assets/nzs-header-late.js
   EXTRACTED from three inline <script> blocks in sections/nzs-header.liquid (zero Liquid):
   announcement-rotator PRM pause, NZS-CDR-CHECKOUT (minus the beforeunload bfcache-killer,
   prefetch listeners consolidated - items 5+6), NZS-ATC-FEEDBACK (verbatim). Emitted with
   defer at the rotator's old position so document order keeps the original relative execution
   order: rotator -> CDR -> ATC -> nzs-overlay -> mega -> drawer. */
/* -- announcement rotator PRM pause -- */
(function(){
  var items=document.querySelectorAll('.ann, .ann .wrap, .ann .ann-item'); if(!items.length||!window.matchMedia) return;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  function sync(){ items.forEach(function(item){ item.style.animationPlayState=reduce.matches?'paused':''; }); }
  if(reduce.addEventListener) reduce.addEventListener('change',sync); else if(reduce.addListener) reduce.addListener(sync);
  sync();
})();
/* -- NZS-CDR-CHECKOUT - 3-dots loader on click + prefetch /checkout on intent -- */
(function(){
  var PF=false;
  var coNavigationStarted=false;
  function prefetch(){ if(PF) return; PF=true; try{ var l=document.createElement('link'); l.rel='prefetch'; l.href='/checkout'; document.head.appendChild(l); /* NZS-CDR-PRECONNECT-0906 */ var pc=document.createElement('link'); pc.rel='preconnect'; pc.href='https://shop.app'; document.head.appendChild(pc); }catch(e){} }
  window.__nzsCoPrefetch = prefetch; /* exposed for the separate cart-drawer IIFE to call on non-empty-cart open — ponytail: skips speculation-rules prerender (impossible across the shop.app 302 checkout hop) and skips a shop.app preconnect (Shopify auto-injects it) */
  function isCo(t){ return t && t.closest && t.closest('#nzsCdrCheckout, #checkout-submit'); }
  /* NZS-SPD-0820 item 6: was 5 document-level capture listeners (pointerenter in capture fired
     on EVERY element the pointer crossed, page-wide, forever). Hover intent binds to the drawer's
     checkout button directly; document keeps pointerdown (supersedes touchstart/mousedown, pens
     fire it) + focus for keyboards - both still cover #checkout-submit on the cart page. */
  var _co = document.getElementById('nzsCdrCheckout');
  if (_co) _co.addEventListener('pointerenter', prefetch, { passive:true });
  ['pointerdown','focus'].forEach(function(ev){
    document.addEventListener(ev, function(e){ if(isCo(e.target)) prefetch(); }, { capture:true, passive:true });
  });
  function coOff(a){ if(!a) return; clearTimeout(a._nzsCoBusyTimer); delete a._nzsCoBusyTimer; a.classList.remove('is-loading'); a.removeAttribute('aria-busy'); }
  function coNavigationOn(){ coNavigationStarted=true; }
  window.addEventListener('pagehide',coNavigationOn);
  document.addEventListener('click', function(e){ var a=isCo(e.target); if(!a) return;
    /* NZS-CDR-GIFTGATE: pointer-events:none stops the mouse but NOT Enter on a focused anchor, and
       a blocked control must never show the loading dots either. Capture phase, so this lands
       before the theme's own handlers. */
    if(a.classList.contains('is-blocked')){ e.preventDefault(); e.stopPropagation(); return; }
    /* NZS-SPEED-LDR-CHECKOUT: mirror visual state into the accessibility tree, with a defensive recovery if another validator prevents submit. */
    coNavigationStarted=false; a.classList.add('is-loading'); a.setAttribute('aria-busy','true'); clearTimeout(a._nzsCoBusyTimer); a._nzsCoBusyTimer=setTimeout(function(){ if(document.visibilityState==='visible'&&!coNavigationStarted) coOff(a); },8000); }, true);
  window.addEventListener('pageshow', function(){ coNavigationStarted=false; coOff(document.getElementById('nzsCdrCheckout')); coOff(document.getElementById('checkout-submit')); });
})();
/* -- NZS-ATC-FEEDBACK -- */
(function(){
  if(window.__nzsAtcFeedbackInstalled) return;
  window.__nzsAtcFeedbackInstalled=true;
  var cartRoot=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var SEL='.button--quickview.button-solid, button[id^="x-atc-button-"]:not([id^="x-atc-button-sticky"]), [data-satc-btn]';
  var ADD_SEL=SEL+', .nzs-qa__atc, [data-nzs-qa-add]';
  function badge(n){ var d=document.getElementById('nzsCartDot'); if(d){ d.textContent=n; d.style.display=n>0?'':'none'; } }
  /* NZS-SPEED-LDR: shared load contract for ATC, drawer, and quick-add controls. */
  /* NZS-CDR-BUSY-GRACE-0922: visual grace is independent of the unchanged 9s safety timer. */
  function loadOn(btn){
    if(!btn||btn.classList.contains('nzs-added')||btn._nzsLoadTimer) return;
    btn.setAttribute('aria-busy','true');
    /* NZS-LOADER-NOGRACE-0923 (Blake): the dots show the moment loading starts; the 1 s grace left buttons greyed out with no animation. */
    btn.classList.add('nzs-loading');
    if(!btn.querySelector('.nzs-atc-dots')){ var dots=document.createElement('span'); dots.className='nzs-atc-dots'; dots.setAttribute('aria-hidden','true'); dots.innerHTML='<i></i><i></i><i></i>'; btn.appendChild(dots); }
    btn._nzsLoadTimer=setTimeout(function(){ loadOff(btn); },36000); /* NZS-LOADER-0923-L5: outlive nzsATC's worst case (18s queue wait + 16s add deadline = 34s) */
  }
  function loadOff(btn){ if(!btn) return; clearTimeout(btn._nzsLoadVisualTimer); delete btn._nzsLoadVisualTimer; clearTimeout(btn._nzsLoadTimer); delete btn._nzsLoadTimer; btn.classList.remove('nzs-loading'); btn.removeAttribute('aria-busy'); var d=btn.querySelector('.nzs-atc-dots'); if(d) d.remove(); }
  window.__nzsLoadOn=loadOn; window.__nzsLoadOff=loadOff;
  /* NZS-LOADER-0923-L4: PDP main ATC keeps the theme's own Alpine loader; this flag only routes its "Added" state. */
  function awaitOff(btn){ clearTimeout(btn._nzsAwaitTimer); delete btn._nzsAwaitTimer; delete btn._nzsAwaitAdd; }
  /* NZS-LOADER-0923-L4: Alpine's own add is running only while its spinner is shown (x-show clears display:none). */
  function alpineBusy(btn){ var sp=btn.querySelector('.animate-spin'); return !!(sp&&!sp.hasAttribute('x-cloak')&&sp.style.display!=='none'); }
  function added(btn){ if(!btn) return; loadOff(btn); awaitOff(btn); if(btn.classList.contains('nzs-added')) return; btn.classList.add('nzs-added'); setTimeout(function(){ btn.classList.remove('nzs-added'); }, 1600); }
  /* NZS-SPEED-LDR: only actual add-to-cart hosts receive the Added state. */
  function flipLoadingToAdded(){ var els=document.querySelectorAll(ADD_SEL); for(var i=0;i<els.length;i++){ var el=els[i]; if(el.classList.contains('nzs-foot-atc')) continue; /* NZS-LOADER-0923-L8: foot ATC's release() clears its own dots; no Added lockout */ if(el._nzsLoadTimer||el.classList.contains('nzs-loading')||(el._nzsAwaitAdd&&alpineBusy(el))) added(el); /* NZS-CDR-BUSY-GRACE-0922 NZS-LOADER-0923-L4: an aborted Alpine add (spinner already hidden) never flips */ } }
  /* NZS-LOADER-0923-L5: a failed theme (non-engine) add clears its host at once. Engine adds retry internally and their
     callers (drawer, quick-add, foot ATC) clear their own buttons, so only the Alpine-driven hosts are listed. */
  var THEME_ADD_SEL='.button--quickview.button-solid, button[id^="x-atc-button-"]:not([id^="x-atc-button-sticky"])';
  /* NZS-LOADER-0923-L5: only the host tapped for this request is cleared (claimed when its fetch starts), so an unrelated
     failed add (quiz, stack, app) never strips another button's dots or a PDP "Added" state. Flip already requires alpineBusy. */
  var lastTheme=null;
  function claimTheme(){ var h=lastTheme; lastTheme=null; return h&&Date.now()-h.t<20000?h.el:null; }
  function clearAdds(el){ if(el&&el._nzsLoadTimer) loadOff(el); }
  /* --- NZS add-to-cart confirmation toast (EA-style) — reuses the .nzs-toast shell --- */
  var HOST_ID='nzs-atc-toast-host', toastTimer=null;
  var TICK='<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M16.7 5.3a1 1 0 0 1 0 1.4l-7.5 7.5a1 1 0 0 1-1.4 0l-3.5-3.5a1 1 0 1 1 1.4-1.4l2.8 2.8 6.8-6.8a1 1 0 0 1 1.4 0z"/></svg>';
  function dismissToast(host){
    clearTimeout(toastTimer);
    if(host&&host.firstChild) host.firstChild.classList.remove('is-in');
  }
  function scheduleToast(host,delay){
    clearTimeout(toastTimer);
    if(host&&host.matches&&host.matches(':hover')) return;
    toastTimer=setTimeout(function(){ dismissToast(host); },delay);
  }
  function ensureHost(){
    var h=document.getElementById(HOST_ID);
    if(!h){ h=document.createElement('div'); h.id=HOST_ID; document.body.appendChild(h); }
    if(!h.__nzsToastBound){
      h.__nzsToastBound=true;
      h.addEventListener('click',function(e){
        var close=e.target.closest&&e.target.closest('[data-nzs-toast-dismiss]');
        if(close&&h.contains(close)){ e.preventDefault(); dismissToast(h); }
      });
      h.addEventListener('mouseenter',function(){ clearTimeout(toastTimer); });
      h.addEventListener('mouseleave',function(){
        if(h.firstChild&&h.firstChild.classList.contains('is-in')) scheduleToast(h,1500);
      });
    }
    return h;
  }
  function showToast(){
    var host=ensureHost();
    var el=host.firstChild;
    /* coalesce: a burst of adds (e.g. product + auto free-gift) reuses the visible toast + resets its timer, instead of re-creating it */
    if(el && el.classList && el.classList.contains('is-in')){ scheduleToast(host,3600); return; }
    host.innerHTML='<div class="nzs-toast" role="status" aria-live="polite"><button class="nzs-toast__dismiss" type="button" aria-label="Dismiss" data-nzs-toast-dismiss>&times;</button><div class="nzs-toast__ic">'+TICK+'</div><div class="nzs-toast__body"><div class="nzs-toast__msg">Added to cart</div></div><a class="nzs-toast__cta" href="/cart" data-nzs-viewcart>View cart &rarr;</a></div>';
    el=host.firstChild;
    setTimeout(function(){ if(el) el.classList.add('is-in'); }, 20);
    scheduleToast(host,3600);
  }
  function showCartError(message,title){
    var host=ensureHost();
    host.innerHTML='<div class="nzs-toast is-in" role="alert" aria-live="assertive" aria-atomic="true"><button class="nzs-toast__dismiss" type="button" aria-label="Dismiss" data-nzs-toast-dismiss>&times;</button><div class="nzs-toast__body"><div class="nzs-toast__msg">Cart update failed</div><div class="nzs-toast__title"></div></div></div>';
    /* NZS-CDR-STOCKMSG-0821: a stock-cap isn't a failure — let the dispatcher retitle the headline. */
    if(title) host.querySelector('.nzs-toast__msg').textContent=title;
    host.querySelector('.nzs-toast__title').textContent=message||"Couldn't update cart";
    scheduleToast(host,4200);
  }
  document.addEventListener('nzs:cart-error',function(e){ showCartError(e.detail&&e.detail.message, e.detail&&e.detail.title); });
  document.addEventListener('nzs:cart-added',function(e){
    var cart=e.detail&&e.detail.cart;
    flipLoadingToAdded();
    if(cart&&typeof cart.item_count==='number') badge(cart.item_count);
    onCartAdd(cart,e.detail&&e.detail.cdrLink); /* NZS-CDR-SPEED-0922: preserve the gift link owner with its server cart. */
  });
  /* "View cart" on the toast opens the active custom drawer (no hard nav). */
  document.addEventListener('click', function(e){
    var cta=e.target.closest('[data-nzs-viewcart]'); if(!cta) return;
    e.preventDefault();
    var t=document.getElementById('nzsCartToggle');
    if(t){ t.click(); } else { window.location.href='/cart'; }
    dismissToast(document.getElementById(HOST_ID));
  });
  /* --- central /cart/add hook: fires on ANY successful add, however it's made (Alpine fetch, XHR, our own submit-guard, Kite bg adds) --- */
  var hookTimer=null;
  /* NZS-CDR-SPEED-0922: confirmed adds deliver a cart directly to the drawer. Keep the
     gesture/popup gates; the old auto-open timer and second open-time read are unnecessary. */
  var lastGesture=0;
  ['pointerdown','keydown'].forEach(function(ev){ document.addEventListener(ev,function(){ lastGesture=Date.now(); },{capture:true,passive:true}); });
  /* NZS-CDR-SPEED-0922: let the drawer own the one sequenced read for ordinary adds;
     a reconciled cart event can be consumed directly. */
  function onCartAdd(cart,cdrLink){
    flipLoadingToAdded();
    clearTimeout(hookTimer);
    function accept(c){
      if(c) badge(c.item_count);
      var canOpen=!document.querySelector('.nzs-gp.is-live')&&Date.now()-lastGesture<=10000;
      document.dispatchEvent(new CustomEvent('nzs:cdr-added-cart',{detail:{cart:c,open:canOpen,cdrLink:cdrLink}}));
    }
    if(cart&&cart.items&&cart.token){ accept(cart); return; }
    hookTimer=setTimeout(function(){ accept(null); },0);
  }
  function isCartAdd(input,init){
    try{
      var req=typeof Request!=='undefined'&&input instanceof Request;
      var url=new URL(req?input.url:input,location.href);
      var method=String(init&&init.method!=null?init.method:(req?input.method:'GET')).toUpperCase();
      var configured=window.Shopify&&Shopify.routes&&Shopify.routes.cart_add_url;
      var addPath=new URL(configured||cartRoot+'cart/add',location.href).pathname.replace(/\.js$/,'');
      return url.origin===location.origin&&method==='POST'&&(url.pathname===addPath||url.pathname===addPath+'.js');
    }catch(e){ return false; }
  }
  function isForeignCartWrite(input,init){
    if(init&&init.__nzsCartGuardHandled) return false;
    if(isCartAdd(input,init)) return false; /* NZS-CDR-SPEED-0922: onCartAdd owns add refreshes, including bypass adds. */
    try{
      var req=typeof Request!=='undefined'&&input instanceof Request;
      var url=new URL(req?input.url:input,location.href);
      var method=String(init&&init.method!=null?init.method:(req?input.method:'GET')).toUpperCase();
      if(url.origin!==location.origin||method!=='POST') return false;
      var cartPath=new URL('cart/',new URL(cartRoot,location.href)).pathname;
      var actions=['add','change','update','clear'];
      for(var i=0;i<actions.length;i++){
        var path=cartPath+actions[i];
        if(url.pathname===path||url.pathname===path+'.js') return true;
      }
    }catch(e){}
    return false;
  }
  function noteForeignCartWrite(){ document.dispatchEvent(new CustomEvent('nzs:cart-foreign-write')); }
  var _origFetch=window.fetch;
  window.fetch=function(input, init){
    var isAdd=isCartAdd(input,init), isForeignWrite=isForeignCartWrite(input,init);
    var themeAdd=isAdd && !(init&&init.__nzsCartGuardBypass); /* NZS-LOADER-0923-L5 */
    var themeHost=themeAdd?claimTheme():null; /* NZS-LOADER-0923-L5 */
    return _origFetch.apply(this, arguments).then(function(r){
      if(themeAdd && r.ok) onCartAdd(); /* NZS-CDR-SPEED-0922: engine emits the full cart once. */
      if(themeAdd && !r.ok) clearAdds(themeHost); /* NZS-LOADER-0923-L5: 422 etc. no dots left spinning after the error shows */
      if(isForeignWrite && r.ok) noteForeignCartWrite();
      return r;
    },function(err){ if(themeAdd) clearAdds(themeHost); throw err; }); /* NZS-LOADER-0923-L5 */
  };
  var _origOpen=XMLHttpRequest.prototype.open, _origSend=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(method, url){
    this.__nzsIsAdd=isCartAdd(url,{method:method});
    this.__nzsIsCartWrite=isForeignCartWrite(url,{method:method});
    return _origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send=function(){
    if(this.__nzsIsAdd||this.__nzsIsCartWrite){
      this.addEventListener('load', function(){
        if(this.status>=200&&this.status<300){
          if(this.__nzsIsAdd&&!this.__nzsCartGuardBypass) onCartAdd(); /* NZS-CDR-SPEED-0922: preserve native XHR; engine owns bypass adds. */
          if(this.__nzsIsCartWrite) noteForeignCartWrite();
        }
      });
    }
    return _origSend.apply(this, arguments);
  };
  /* Kite bridge: background flows (e.g. free-gift logic) that reload the cart without a fetch/XHR we can see */
  document.addEventListener('theme:cart:reload', function(){ onCartAdd(); });
  /* native-submit guard: a click before Alpine hydrates falls through to a real form submit (full-page nav to /cart, no toast) — AJAX it ourselves instead. No-op once Alpine has hydrated, since its own click handler preventDefaults before the submit event ever fires. */
  document.addEventListener('submit', function(e){
    var f=e.target;
    if(!f||!isCartAdd(f.action,{method:'POST'})||e.defaultPrevented) return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit],button[name=add]');
    if(btn&&btn.dataset.nzsBusy==='1') return;
    if(btn){ btn.dataset.nzsBusy='1'; btn.disabled=true; }
    loadOn(btn);
    var match=location.pathname.match(/\/products\/([^\/?#]+)/);
    var engine=window.nzsATC;
    var add=engine
      ? engine.add(new FormData(f),{handle:match?match[1]:''})
      : Promise.reject(new Error('Please try again'));
    add.then(function(){ if(btn){ delete btn.dataset.nzsBusy; btn.disabled=false; } added(btn); },function(err){
      if(btn){ delete btn.dataset.nzsBusy; btn.disabled=false; awaitOff(btn); /* NZS-LOADER-0923-L4 */ } loadOff(btn);
      if(err&&err.code==='NEEDS_CHOICE'){
        var card=f.closest('.card-product')||f.closest('.nzs-card,.nzs-bs__card');
        var picker=card&&card.querySelector('.quick-view-container button');
        if(picker){ picker.click(); picker.focus(); }
        showCartError((err&&err.message)||'Choose an option');
        return;
      }
      if(!engine) showCartError((err&&err.message)||"Couldn't add to cart");
    });
  }, true);
  /* click listener: loading visual only now — badge/toast/added-flip come from the central hook above once the add actually resolves */
  document.addEventListener('click', function(e){
    var btn=e.target.closest(SEL); if(!btn||btn.disabled) return;
    if(btn.classList.contains('nzs-satc__btn')) return; /* NZS-LOADER-0923-L6: the sticky bar owns its own .is-loading dots */
    var _al=((btn.getAttribute('aria-label')||'')+' '+(btn.textContent||'')).toLowerCase();
    if(_al.indexOf('choose option')>-1) return; /* multi-variant first tap opens the panel, not an add */
    /* NZS-FLY-NODOTS (Blake 2026-07-31): when the fly-to-cart animation is the feedback
       (card / quick-add / sticky sources -- mirrors nzs-fly-to-cart.js's own gating), the
       3-dot loader on a cart-icon button is redundant noise. The PDP form keeps its dots
       (fly-to-cart deliberately excludes it). */
    var _fly=window.nzsFlyToCart;
    if(_fly&&_fly.enabled&&!(_fly.reduced&&_fly.reduced())&&(btn.matches('[data-satc-btn], .nzs-foot-atc')||btn.closest('.card-product, .nzs-bs__card, .nzs-qa'))) return;
    /* NZS-LOADER-0923-L4: the PDP main ATC's Alpine loader (label invisible + spinner, cleared in its own finally)
       already covers the whole wait, so no second loader; repeat taps are swallowed by the window listener below.
       Before Alpine hydrates the spinner is x-cloak'd and the native-submit guard above shows the shared dots instead. */
    if(btn.matches(THEME_ADD_SEL)) lastTheme={el:btn,t:Date.now()}; /* NZS-LOADER-0923-L5 */
    if(btn.matches('button[id^="x-atc-button-"]')){
      awaitOff(btn); btn._nzsAwaitAdd=1; btn._nzsAwaitTimer=setTimeout(function(){ awaitOff(btn); },20000);
      return;
    }
    loadOn(btn);
  }, true);
  /* NZS-LOADER-0923-L4: the main ATC is never disabled by the theme, so a tap while its Alpine spinner shows is stopped at
     window capture, ahead of every document/element listener (incl. the PDP flavour-extras add), so it cannot add twice.
     The first tap passes: the spinner is still display:none (or x-cloak'd before hydration) when it lands. */
  window.addEventListener('click', function(e){
    var b=e.target&&e.target.closest&&e.target.closest('button[id^="x-atc-button-"]:not([id^="x-atc-button-sticky"])');
    if(b&&alpineBusy(b)){ e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  /* [data-nzs-viewcart] handler above is preserved as-is */
})();

/* NZS-TRUST-ROT-0903: one fader for every [data-nzs-rot] bar (announcement bar + trust strip). Rotates only
   <=760px (the CSS fade rules live inside that MQ); chevrons step + reset the timer; reduced-motion = no auto. */
(function(){
  var mq=matchMedia('(max-width:760px)'), rm=matchMedia('(prefers-reduced-motion:reduce)').matches;
  document.querySelectorAll('[data-nzs-rot]').forEach(function(bar){
    var items=bar.querySelectorAll('[data-rot-item]'); if(items.length<2) return;
    var i=0, t=null, ms=+bar.dataset.interval||5000;
    function show(n){ items[i].classList.remove('is-on'); i=(n+items.length)%items.length; items[i].classList.add('is-on'); }
    function stop(){ if(t){ clearInterval(t); t=null; } }
    function start(){ stop(); if(!rm&&mq.matches) t=setInterval(function(){ show(i+1); }, ms); }
    bar.classList.add('is-rot'); items[0].classList.add('is-on');
    bar.addEventListener('click', function(e){ var b=e.target.closest('.nzs-chev'); if(!b) return; show(i+(b.classList.contains('nzs-chev--next')?1:-1)); start(); });
    (mq.addEventListener?mq.addEventListener('change',start):mq.addListener(start)); start();
  });
})();

/* NZS-UPSELL-0911: ponytail: forward existing CRO events instead of adding another analytics SDK. */
(function(){
  /* NZS-UPSELL-0911: ponytail: capture the original dataLayer once instead of rechecking our own event queue. */
  var hadDataLayer=typeof window.dataLayer!=='undefined';
  /* NZS-SPD-0927-SM-D1: the gtag / dataLayer / Shopify.analytics call cost 190-410 ms on a 4x-throttled phone and ran
     inside the drawer's open and render tasks. The event name, the payload and the sink (the gtag function present at
     dispatch, else dataLayer + the publish fallback) are fixed at dispatch exactly as before; the calls run in arrival
     order at the next idle period (<= 2 s), or at once on pagehide / tab hide, so an event fired just before leaving
     still sends. Every sink is resolved AT DISPATCH, as the synchronous code did: the gtag function, else the dataLayer
     array (created there if absent, as before) and the Shopify.analytics publish function with its object, so no event
     is lost if a sink goes away before the flush. Test: src/test_smooth_d1.js (same calls, payloads, order). */
  var croQ=[], croT=0;
  function croSend(x){
    try{
      if(x.g) x.g.call(window,'event',x.ev,x.p);
      else if(x.dl) x.dl.push(Object.assign({event:x.ev},x.p));
    }catch(_){}
    try{
      /* NZS-UPSELL-0911: ponytail: use the captured sink state instead of checking the dataLayer just created above. */
      if(x.pf) x.pf.call(x.po,x.ev,x.p);
    }catch(_){}
  }
  function croFlush(){ croT=0; var a=croQ; croQ=[]; for(var i=0;i<a.length;i++) croSend(a[i]); }
  document.addEventListener('nzs:cro',function(e){
    var d=e.detail||{}, ev='nzs_'+(d.ev||'cro'), p={};
    Object.keys(d).forEach(function(k){
      if(k==='ev') return;
      var v=d[k];
      p[k]=Array.isArray(v)?(k==='pids'?v.slice(0,5):v).join(','):v;
    });
    var g=typeof window.gtag==='function'?window.gtag:null, dl=null, po=null, pf=null;
    try{ if(!g) dl=(window.dataLayer=window.dataLayer||[]); }catch(_){}
    try{ if(!g&&!hadDataLayer&&window.Shopify&&Shopify.analytics&&Shopify.analytics.publish){ po=Shopify.analytics; pf=po.publish; } }catch(_){}
    croQ.push({ev:ev,p:p,g:g,dl:dl,po:po,pf:pf});
    if(!croT) croT=window.requestIdleCallback?window.requestIdleCallback(croFlush,{timeout:2000}):setTimeout(croFlush,0);
  });
  window.addEventListener('pagehide',croFlush,true);
  document.addEventListener('visibilitychange',function(){ if(document.visibilityState==='hidden') croFlush(); },true);
})();
